export enum Permission {
  ColumnMapApprovalRequestsView = 'column_map_approval_requests.view',
}
